import React from 'react';

/**
 * Simple dropdown filter button component
 */
const DropdownFilterButton = ({ 
  isOpen, 
  displayLabel, 
  icon, 
  disabled, 
  className, 
  onClick 
}) => {
  return (
    <div className='cui-border-gray shadow-sm dropdown btn-rounded-5'>
      <div
        onClick={onClick}
        className={`btn btn-sm btn-white shadow-sm waves-effect no-borders d-flex align-items-center btn-rounded-5 cui-dropdown-filter-button ${isOpen ? 'font-600 cui-dropdown-filter-button-open' : ''}`}
      >
        {icon && (
          <i className={`${icon} text-muted px-1`}></i>
        )}
        <span className='nowrap-white-space'>{displayLabel}</span>
        <i
          className={`fa-solid fa-caret-down text-muted px-2 font-12 cui-dropdown-filter-caret ${isOpen ? 'cui-dropdown-filter-caret-rotate' : ''}`}
        ></i>
      </div>
    </div>
  );
};

export default DropdownFilterButton;